import { useEffect, useState } from "react";
import { _CompetitionType, _Entailment, _MacroProcess, _single, _SubMacroProcess } from "../../../../core/services/dataBean/EntityCatalog";

import { Singleton } from "../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable, MASK_MONEY } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { PrintJson } from "../../../theme/Component/PrintJson";
import { PrintObjectJson } from "../../../theme/Component/PrintObjectJson";
import { _WelfarePaymentByIncapacity } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { FileService } from "../../../../core/services/FileService";
import { WelfareEntityEditorTable } from "../../WelfareEntity/WelfareEntityEditorTable";
import { InputMoney } from "../../../theme/Input/InputMoney";
import { FileInput } from "../../../theme/Component/FileInput";
import { InputDate } from "../../../theme/Input/InputDate";

interface Props {
    idDocument: number;
    documentDate: any;
    NoveltyID: any
}

export const WelfarePaymentByIncapacity = ({ idDocument, documentDate, NoveltyID }: Props) => {

    const wlfare = useDataBean(_WelfarePaymentByIncapacity);

    const single = Singleton.getInstance();
    const fileService = new FileService();
    const [lista, setLista] = useState<any>([]);
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [idDocument, documentDate, NoveltyID])

    const getLista = () => {

        wlfare.instance.getIncapacityWelfarePaymentByIncapacity(idDocument, documentDate, NoveltyID).then(
            (resp: any) => {
                if (resp) {
                    let tmp = resp;
                    tmp.forEach((element: any) => {
                        if (element.DataBeanProperties.MediaContext) {
                            element.DataBeanProperties.URL = ` <a href="${fileService.getUrlFile(element.DataBeanProperties.MediaContext, element.DataBeanProperties.Media)}" target='_blank'>DESCARGAR DOCUMENTO</a>`
                        } else {
                            element.DataBeanProperties.URL = "Sin Documento";
                        }
                    });
                    setLista(tmp);
                }
            }
        )

    }


    const deleteItem = () => {
        wlfare.instance.deleteIncapacityWelfarePayments(wlfare.bean.IDIncapacityWelfarePayment, wlfare.bean.IDDocument, wlfare.bean.DocumentDate).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }

    const create = () => {
        wlfare.setBean({
            IDEmployee: _single.getAccountID(),
            IDDocument: idDocument,
            DocumentDate: documentDate,
            NoveltyID: NoveltyID
        });
        console.log(wlfare.bean)
        setModal({ ...modal, "view": true });
    }

    const editaItem = () => {
        if (!wlfare.bean.IDWelfareEntity) {
            toast.warning("Debe seleccionar un Fondo Pagador.");
            return;
        }
        if (!wlfare.bean.PaidValue) {
            toast.warning("Debe seleccionar un Valor Pagado.");
            return;
        }
        if (!wlfare.bean.Description) {
            toast.warning("Debe dar una Descripción.");
            return;
        }


        wlfare.instance.updateIncapacityWelfarePayment(wlfare.bean).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const head = [
        { title: 'ID', property: 'IDIncapacityWelfarePayment', visible: true },
        { title: 'Tipo Documento', property: 'MnemonicCNA', visible: true },
        { title: 'Consecutivo Documento', property: 'ConsecutiveCNA', visible: true },
        { title: 'Fecha Documento', property: 'DocumentDateCNA', visible: true },
        { title: 'Fondo Pagador', property: 'WelfareEntityName', visible: true },
        { title: 'Valor Pagado', property: 'PaidValue', visible: true, mask: MASK_MONEY },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Archivo Soporte', property: 'URL', visible: true },
        { title: 'Fecha de Pago', property: 'PaymentDate', visible: true },
        { title: 'Actualizado por', property: 'EmployeeName', visible: true },
        { title: 'Fecha Actualización', property: 'Since', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <div className="row">
            <div className="col-md-12">
                <BasicPage titulo="Consultar Pagos Realizados por la Entidad">
                    <BasicTable body={lista} head={head} rowSet={wlfare.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-12">
                                <label >Fondo Pagador</label>
                                <WelfareEntityEditorTable render={wlfare.bean.NameWell} idSelector={wlfare.bean.IDWelfareEntity} onChange={(e) => { wlfare.setBean({ ...wlfare.bean, "IDWelfareEntity": e.IDWelfareEntity, "NameWell": e.AccountName }) }} label=" " returnType="Object" />
                                {/* <AccountEditor idAccount={bean.IDAccount} label="Empleado" onChange={(e) => { setBean({ ...bean, IDAccount: e.IDAccount }) }} /> */}
                            </div>
                            <div className="col-md-12">
                                <InputDate name="PaymentDate" label="Fecha de la hoja de transferencia" value={wlfare.bean.PaymentDate} setDate={(e: any) => { wlfare.setBean({ ...wlfare.bean, "PaymentDate": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <InputMoney _label="Valor Pagado" _value={wlfare.bean.PaidValue} onChange={(e) => { wlfare.setBean({ ...wlfare.bean, "PaidValue": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <FileInput Media={wlfare.bean.Media} MediaContext={wlfare.bean.MediaContext} label="Archivo Soporte" directory="incapacity"
                                    onCreate={(e: any) => wlfare.setBean({ ...wlfare.bean, 'Media': e.Media, 'MediaContext': e.MediaContext })}
                                ></FileInput>
                            </div>

                            <div className="col-md-12">
                                <label>Description</label>
                                <textarea name="Description" className="form-control" value={wlfare.bean.Description} onChange={wlfare.handleChange} />
                            </div>
                            {/* <PrintJson json={SubMacroProcess.bean} /> */}
                        </div>
                    </Modal>

                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item</strong>
                    </ModalConfirm>
                </BasicPage>

            </div>

        </div>
    )
}